export const CCPA_ANALYTICS = "il_squeeze_analytics";
export const CCPA_MARKETING = "il_squeeze_marketing";
export const CCPA_PERSONALIZATION = "il_squeeze_personalization";
